/* eslint-disable no-underscore-dangle */
import React, { useState, useContext } from "react";
import DatePicker from "react-datepicker";
import { useIntl } from "react-intl";
import moment from "moment";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import "./dateFilter.scss";

import AnalyticsContext from "./analyticsContext";

export function DemoDatePicker() {
  const intl = useIntl();
  const ctx = useContext(AnalyticsContext);

  const [calenderOpen, setCalenderOpen] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("year")._d);
  const [endDate, setEndDate] = useState(moment()._d);

  const handleClickOutside = (e) => {
    if (!e.target.closest(".react-datepicker")) {
      setCalenderOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  const dateRanges = [
    {
      value: 1,
      label: intl.formatMessage({
        id: "report.thisWeek",
        defaultMessage: "This Week",
      }),
      key: "this_week",
    },
    {
      value: 2,
      label: intl.formatMessage({
        id: "report.lastWeek",
        defaultMessage: "Last Week",
      }),
      key: "last_week",
    },
    {
      value: 3,
      label: intl.formatMessage({
        id: "report.thisMonth",
        defaultMessage: "This Month",
      }),
      key: "this_month",
    },
    {
      value: 4,
      label: intl.formatMessage({
        id: "report.lastMonth",
        defaultMessage: "Last Month",
      }),
      key: "last_month",
    },
    {
      value: 5,
      label: intl.formatMessage({
        id: "report.yearToDate",
        defaultMessage: "Year to Date",
      }),
      key: "year_to_date",
    },
    {
      value: 6,
      label: intl.formatMessage({
        id: "report.lastYear",
        defaultMessage: "Last Year",
      }),
      key: "last_year",
    },
    {
      value: 7,
      label: intl.formatMessage({
        id: "report.lastYearToDate",
        defaultMessage: "Last Year to Date",
      }),
      key: "last_year_to_date",
    },
    {
      value: 8,
      label: intl.formatMessage({
        id: "report.customDateRange",
        defaultMessage: "Custom Date Range",
      }),
      key: "custom_date_range",
    },
  ];

  // Incase of custom range, show the calender and handle date change
  function handleDateChange(dates) {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      ctx.setCustomDateRange(start, end);
      setCalenderOpen(false);
    }
  }

  function formatDate() {
    if (calenderOpen) {
      return "Custom Date Range";
    }

    if (startDate && endDate) {
      if (
        moment(startDate).format("YYYY") === moment(endDate).format("YYYY") &&
        moment(startDate).format("YYYY") === moment().format("YYYY")
      ) {
        return `${moment(startDate).format("DD MMM")} - ${moment(endDate).format("DD MMM")}`;
      }
      return `${moment(startDate).format("DD MMM YYYY")} - ${moment(endDate).format("DD MMM YYYY")}`;
    }
    return "Select Date Range";
  }

  const handleDateFilter = (dateRange) => {
    switch (dateRange) {
      case "this_week":
        setStartDate(moment().startOf("isoWeek")._d);
        setEndDate(moment().endOf("isoWeek")._d);
        break;
      case "last_week":
        setStartDate(moment().subtract(1, "weeks").startOf("isoWeek")._d);
        setEndDate(moment().subtract(1, "weeks").endOf("isoWeek")._d);
        break;
      case "this_month":
        setStartDate(moment().startOf("month")._d);
        setEndDate(moment().endOf("month")._d);
        break;
      case "last_month":
        setStartDate(moment().subtract(1, "months").startOf("month")._d);
        setEndDate(moment().subtract(1, "months").endOf("month")._d);
        break;
      case "year_to_date":
        setStartDate(moment().startOf("year")._d);
        setEndDate(moment()._d);
        break;
      case "last_year":
        setStartDate(moment().subtract(1, "years").startOf("year")._d);
        setEndDate(moment().subtract(1, "years").endOf("year")._d);
        break;
      case "last_year_to_date":
        setStartDate(moment().subtract(1, "years").startOf("year")._d);
        setEndDate(moment()._d);
        break;
      case "custom_date_range":
        setCalenderOpen(true);
        setStartDate(new Date());
        break;
      default:
        break;
    }
  };

  return (
    <div className="d-flex flex-direction-column position-relative">
      <div className="date-filter" style={{ width: "200px" }}>
        <Dropdown
          value={formatDate()}
          options={dateRanges}
          onChange={(item) => {
            handleDateFilter(item.key);
            ctx.setDateRange(item.key);
          }}
          defaultValue={intl.formatMessage({
            id: "report.dateRange",
            defaultMessage: "Date range",
          })}
        />
      </div>

      {calenderOpen && (
        <div
          className="position-absolute date-filter-container"
          style={{ zIndex: 9999, top: 35, left: "50%", transform: "translateX(-50%)" }}
        >
          <DatePicker
            onChange={handleDateChange}
            selectsStart
            selected={startDate}
            startDate={startDate}
            endDate={endDate}
            inline
            portalId="root-portal"
            selectsRange
            showDisabledMonthNavigation
            {...(startDate && { maxDate: moment(startDate).add(1, "year").toDate() })}
          />
        </div>
      )}
    </div>
  );
}

export default DemoDatePicker;
